class CartTable {
  constructor() {
    this.el = document.querySelector('.template-cart .main-content');
    if (!this.el) return;
    this.table = this.el?.querySelector('.cart-section');
    this.tableContent = this.table?.querySelector('.row-items');
    this.noImage = 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';

    
    window.cartService.load();

    window.cartService.subscribe(cart => {
      this.render(cart)
      this.updateSubtotal(cart);
      this.emptyCartStateCartTable(cart);
    });

    this.bindEvents();
  }

  bindEvents() {
    this.table.addEventListener('click', e => {
      if (e.target.matches('.qtyplus1, .qtyminus1')) {
        const wrap = e.target.closest('.qty-box-set');
        const input = wrap.querySelector('.quantity-selector');

        if (!input) return;
        const cart = window.cartService.cart;
        const variantId = input.dataset.variantId;
        const selectedElement = cart.items.find(element => element.variant_id == variantId);
        const max = selectedElement.properties.maxQty;

        let qty = parseInt(input.value) || 0;
        qty = e.target.classList.contains('qtyplus1')
          ? Math.min(max, qty + 1)
          : Math.max(0, qty - 1);

        console.log(qty);
        

        window.cartService.change(variantId, qty);
      }

      const remove = e.target.closest('.cart__remove');
      if (remove) {
        window.cartService.change(remove.dataset.variantId, 0);
      }
    });

    this.table.addEventListener('change', e => {
      if (!e.target.matches('.quantity-selector')) return;
      const cart = window.cartService.cart;
      const variantId = e.target.dataset.variantId;
      const selectedElement = cart.items.find(element => element.variant_id == variantId);
      const max = selectedElement.properties.maxQty;

      let qty = Number(e.target.value);
      const min = Number(e.target.min) || 0;

      qty = Math.min(max, Math.max(min, qty));

      console.log(qty);

      window.cartService.change(
        e.target.dataset.variantId,
        qty
      );
    });
  }

  render(cart) {
    if (!this.tableContent) return;
    this.tableContent.innerHTML = cart.items.map(item => this.cartItemHTML(item)).join('');
  }

  cartItemHTML(item) {
    const itemImage = item.image ?? globalThis.noImage;
      const variantTitle =
        item.variant_title && !item.variant_title.includes('Default')
          ? `<br><small>${item.variant_title}</small>`
          : '';

      const vendorHTML = item.vendor
        ? `<p>${item.vendor}</p>`
        : '';

      const propertiesHTML = item.properties
        ? Object.entries(item.properties)
            .filter(([_, v]) => v)
            .map(([k, v]) => `
              <li class="product-details__item product-details__item--property">
                <span class="product-details__item-label">${k}: </span>
                <span>
                  ${
                    typeof v === 'string' && v.includes('/uploads/')
                      ? `<a href="${v}">Uploaded File</a>`
                      : v
                  }
                </span>
              </li>
            `)
            .join('')
        : '';

      const hasDiscount = item.original_line_price > item.final_line_price;

      return `
      <div class="cart__row-item" data-variant-id="${item.variant_id}">
        <div class="grid--full cart__row--table-large text-center">

          <!-- PRODUCT -->
          <div class="grid__item six-tenths">
            <div class="grid cart_items">

              <div class="grid__item wide--one-half">
                <a href="${item.url}" class="cart__image">
                  <img src="${itemImage}" alt="${item.title}">
                </a>
              </div>

              <div class="grid__item wide--one-half cart-title">
                <a href="${item.url}" class="h5">${item.product_title}</a>
                ${variantTitle}
                ${vendorHTML}

               
              </div>

            </div>
          </div>

          <!-- QTY / TOTAL / REMOVE -->
          <div class="grid__item four-tenths">
            <div class="grid--full cart__row--table-large">

              <!-- QTY -->
              <div class="grid__item qty-box-wrapper one-quarter small--one-fifth text-center">
                <span class="h4 cart__large-labels">Quantity</span>
                <div class="qty-box-set">
                  <button type="button" class="qtyminus1">-</button>
                  <input
                    type="number"
                    class="quantity-selector cart-number"
                    data-variant-id="${item.variant_id}"
                    value="${item.quantity}"
                    min="0">
                  <button type="button" class="qtyplus1">+</button>
                </div>
                 <a href="#" class="cart__remove" data-key="${item.key}" data-variant-id="${item.variant_id}">
                    <span class="h4 underline-remove">Remove</span>
                  </a>
              </div>

              <!-- TOTAL -->
              <div class="grid__item one-quarter small--one-fifth">
                <span class="h4 cart__large-labels">Total</span>
                <span class="h5">

                  ${
                    hasDiscount
                      ? `<small class="cart-item__original-price" data-variant-id="${item.variant_id}">
                          <s>${this.formatMoney(item.original_line_price)}</s>
                        </small>`
                      : ''
                  }

                  <div class="qb-total-line-item" data-id="${item.key}" data-variant-id="${item.variant_id}">
                    ${this.formatMoney(item.final_line_price)}
                  </div>

                </span>

                ${
                  hasDiscount && item.discounts
                    ? item.discounts
                        .map(d => `<small class="cart-item__discount">${d.title}</small>`)
                        .join('')
                    : ''
                }
              </div>

            </div>
          </div>

        </div>
      </div>
      `;
    }

  money(cents) {
    return (cents / 100).toLocaleString('id-ID', {
      style: 'currency',
      currency: 'IDR'
    });
  }

  updateSubtotal(cart) {
    this.table.querySelectorAll('.cart__subtotal .hidePrice')
      .forEach(el => {
        el.textContent = this.formatMoney(cart.total_price);
      });
  }

  emptyCartStateCartTable(cart) {
      if (!cart) return;

      const tableItems = this.table;
      const emptyCart = this.el.querySelector('.cart_empty_msg');

      if (cart.item_count === 0) {


          tableItems.classList.add('cart-drawer__items--hide');
          tableItems.classList.remove('cart-drawer__items--show');


          emptyCart.classList.add('cart-drawer__items--show');
          emptyCart.classList.remove('cart-drawer__items--hide');


        this.table.querySelectorAll('.cart__subtotal .hidePrice')
          .forEach(el => {
            el.textContent = this.formatMoney(0);
          });

      } else {

        tableItems.classList.remove('cart-drawer__items--hide');
        tableItems.classList.add('cart-drawer__items--show');

        emptyCart.classList.remove('cart-drawer__items--show');
        emptyCart.classList.add('cart-drawer__items--hide');

      }
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }

}

new CartTable();